"use client"

import { faCity, faGlobe, faHotel, faLocationDot } from "@fortawesome/free-solid-svg-icons"
import { useTranslation } from "react-i18next"

/** Icon cố định popover địa điểm hotel — đồng bộ với flight (city / globe). */
export const hotelDestinationIcons = {
  CITY: faCity,
  COUNTRY: faGlobe,
  AREA: faLocationDot,
  HOTEL: faHotel,
} as const

export const hotelDestinationGroupIcons = {
  INTERNAL: faCity,
  EXTERNAL: faGlobe,
} as const

export const useLocationType = () => {
  const { t } = useTranslation()
  return {
    labels: {
      CITY: t("common.city"),
      HOTEL: t("common.accommodation"),
      COUNTRY: t("common.country"),
      AREA: t("common.area"),
    } as Record<string, string>,
    icons: hotelDestinationIcons,
    groupIcons: hotelDestinationGroupIcons,
  }
}
